import { BRAND } from "../brand";

/** Bildirimler, duyurular, bilgi bankası ve "Eksikleri göster" metinleri. */
export const comms = {
  /** Bildirim tercihleri ekranında tür etiketleri. */
  kinds: {
    leave_submitted: "Onayınızı bekleyen izin talepleri",
    leave_approved: "İzniniz onaylandığında",
    leave_rejected: "İzin talebiniz reddedildiğinde",
    leave_returned: "İzin talebiniz düzeltmeye gönderildiğinde",
    leave_cancelled: "Ekibinizden izin iptalleri",
    leave_step_approved: "İzin talebiniz bir adım ilerlediğinde",
    approval_rerouted: "Size devredilen onaylar",
    approval_reminder: "Geciken onay hatırlatmaları",
    delegation_started: "Size vekâlet verildiğinde",
    document_requested: "Sizden belge istendiğinde",
    document_reviewed_accepted: "Belgeniz kabul edildiğinde",
    document_reviewed_rejected: "Belgeniz yeniden istendiğinde",
    payslip_published: "Bordronuz yayımlandığında",
    task_assigned: "Size görev atandığında",
    checklist_completed: "İşe giriş/çıkış listesi tamamlandığında",
    expense_submitted: "Onayınızı bekleyen masraflar",
    expense_approved: "Masrafınız onaylandığında",
    expense_rejected: "Masrafınız reddedildiğinde",
    expense_returned: "Masrafınız düzeltmeye gönderildiğinde",
    expense_paid: "Masrafınız ödendiğinde",
    advance_submitted: "Onayınızı bekleyen avanslar",
    advance_approved: "Avansınız onaylandığında",
    advance_rejected: "Avansınız reddedildiğinde",
    advance_paid: "Avansınız ödendiğinde",
    announcement: "Yeni duyurular",
    asset_assigned: "Size zimmet atandığında",
    support_session_started: `${BRAND.name} destek ekibi oturum açtığında`,
  },
  /**
   * Push bildirimi metinleri: kilit ekranında görünür, bu yüzden kişi adı, tarih, tutar gibi
   * kişisel veri içermez. Ayrıntı uygulama açılınca sunucudan okunur (design/mobile/README.md).
   */
  push: {
    title: BRAND.name,
    generic: {
      approval_request: "Onayınızı bekleyen bir talep var.",
      leave_update: "İzin talebinizle ilgili bir güncelleme var.",
      team_leave_cancelled: "Ekibinizden bir izin talebi iptal edildi.",
      delegation: "Size onay vekâleti verildi.",
      document_requested: "Sizden bir belge istendi.",
      document_update: "Belgenizle ilgili bir güncelleme var.",
      payroll: "Yeni bir bordro belgeniz var.",
      task: "Size yeni bir görev atandı.",
      checklist_done: "Takip ettiğiniz bir süreç tamamlandı.",
      money_update: "Masraf veya avans talebinizle ilgili bir güncelleme var.",
      announcement: "Yeni bir duyuru var.",
      asset: "Size yeni bir zimmet verildi.",
      support: `${BRAND.name} destek ekibi şirket hesabınızda salt okunur bir oturum açtı.`,
      other: "Yeni bir bildiriminiz var.",
    },
  },
  kindGroups: {
    leave: "İzin",
    approvals: "Onaylar ve vekâlet",
    documents: "Belgeler",
    payroll: "Bordro",
    tasks: "Görevler",
    expenses: "Masraf ve avans",
    announcements: "Duyurular",
    assets: "Zimmet",
    security: "Hesap güvenliği",
  },
  announcements: {
    audience: {
      all: "Herkes",
      branches: "Şubeler: {names}",
      departments: "Birimler: {names}",
    },
  },
  knowledge: {
    noResults: "Bu konuda bir politika bulunamadı; İK ekibine sorabilirsiniz.",
  },
  issues: {
    labels: {
      missing_manager: "Yöneticisi yok",
      missing_department: "Birimi yok",
      missing_national_id: "TC kimlik no yok",
      missing_iban: "IBAN yok",
      missing_emergency_contact: "Acil durum kişisi yok",
      missing_required_document: "Zorunlu belge eksik",
      expired_document: "Belgenin süresi dolmuş",
      missing_custom_field: "Zorunlu alan boş",
      no_account: "Hesabı yok",
      pending_invitation: "Davet bekliyor",
      missing_opening_balance: "İzin açılış bakiyesi yok",
    },
    detail: {
      missing_manager: "Yönetici atanmamış; izin onayları kimseye düşmez.",
      missing_department: "Bir birime bağlı değil.",
      missing_national_id: "TC kimlik numarası girilmemiş.",
      missing_iban: "Ödemeler için IBAN girilmemiş.",
      missing_emergency_contact: "Acil durumda aranacak kişi girilmemiş.",
      missing_custom_field: "Zorunlu alan boş: {label}.",
      no_account: "Uygulama hesabı yok; davet de gönderilmemiş.",
      pending_invitation: "Davet {date} tarihinde gönderildi, henüz kabul edilmedi.",
      pending_invitation_expired: "Davetin süresi {date} tarihinde doldu; yeniden davet gönderin.",
      missing_opening_balance: "Kıdemi {years} yıl, ama yıllık izin açılış bakiyesi girilmemiş; bakiyesi eksik görünür.",
    },
    notes: {
      topPerson: "{name}, yöneticisi olmayan ve ekibi olan tek kişi olduğu için şirketin en üst kişisi sayıldı; \"Yöneticisi yok\" listesine alınmadı.",
      executives: "Şirket yöneticisi rolündeki kişiler yöneticisiz olabilir; \"Yöneticisi yok\" listesine alınmadı.",
      multipleRoots: "Yöneticisi olmayan {count} ekip başı var; en üst kişi belirlenemediği için hepsi listelendi.",
    },
  },
  summary: {
    roleTitleDept: "{name}, {department} biriminde {title} olarak çalışıyor.",
    roleDept: "{name}, {department} biriminde çalışıyor.",
    roleTitle: "{name}, {title} olarak çalışıyor.",
    roleNone: "{name} için birim ve unvan bilgisi girilmemiş.",
    branch: "Şube: {branch}.",
    manager: "Yöneticisi: {manager}.",
    noManager: "Yöneticisi atanmamış.",
    seniority: "Kıdem: {duration} ({date} tarihinden beri).",
    seniorityNew: "Kıdem: 1 aydan az ({date} tarihinden beri).",
    startsOn: "İşe başlama tarihi: {date}.",
    status: {
      preboarding: "Henüz işe başlamadı.",
      offboarding: "Ayrılık süreci devam ediyor.",
      terminated: "İşten ayrıldı.",
    },
    years_one: "{count} yıl",
    years_other: "{count} yıl",
    months_one: "{count} ay",
    months_other: "{count} ay",
    annualLeave: "Yıllık izin: {available} kullanılabilir.",
    annualLeavePending: "Yıllık izin: {available} kullanılabilir ({pending} onay bekliyor).",
    noPending: "Bekleyen talebi yok.",
    pending: "Bekleyen talepler: {list}.",
    pendingLeave_one: "{count} izin talebi",
    pendingLeave_other: "{count} izin talebi",
    pendingExpense_one: "{count} masraf",
    pendingExpense_other: "{count} masraf",
    pendingAdvance_one: "{count} avans talebi",
    pendingAdvance_other: "{count} avans talebi",
    noIssues: "Açık eksik yok.",
    issues: "Açık eksikler: {list}.",
  },
};
